"use strict";

var CITY_NAME = {
  "bj": {
    "name": "新航道在线",
    "activity": "暑假班火热报名中，2-3人团报享8.5折优惠！",

    "alink": "https://chat6843.talk99.cn/chat/chat/p.do?_server=0&encrypt=1&c=20002143&f=10071421&g=10068864&refer=XX"
  },
  "nj": {
    "name": "新航道沈阳学校",
    "activity": "新航道沈阳学校暑假班课程优惠6折起",

    "alink": "http://chat.looyuoms.com/chat/chat/p.do?c=20002143&f=10072969&g=10069614&refer=gdlj"
  },
  "sh": {
    "name": "新航道大连学校",
    "activity": "新航道大连学校暑假班课程优惠6折起",

    "alink": "http://chat.looyuoms.com/chat/chat/p.do?c=20002143&f=10095904&g=10079736&refer=gdlj"
  },
  "wh": {
    "name": "新航道佛山学校",
    "activity": "暑假班8.5折起优惠，火热报名中！",

    "alink": "http://chat6843.talk99.cn/chat/chat/p.do?g=10085848&md=2&c=20002143&v="
  },
  "hz": {
    "name": "新航道天津学校",
    "activity": "4月预订暑期6月课程低至78折",

    "alink": "https://chat6842.talk99.cn/chat/chat/p.do?g=10086298&md=2&c=20002143&v=fc7d9846e61642cb8fed2b61c2a88109&u=d3aa137fd7d1a0d93c3f3081e48687ed&f=10115281&site=38536&p0=https%3A%2F%2Ftj.xhd.cn%2F&ct=1&refer=&loc=https%3A%2F%2Ftj.xhd.cn%2F&_d=1604025644304"
  },
  "qd": {
    "name": "新航道广州学校",
    "activity": "线上咨询即享暑假班8.5折起优惠",

    "alink": "https://chat6842.talk99.cn/chat/chat/p.do?_server=0&encrypt=1&c=20002143&f=10068064&g=10066735&refer=gdlj"
  },
  "jn": {
    "name": "新航道北京学校",
    "activity": "暑假班火热报名中，2-3人团报享8.5折优惠！",

    "alink": "https://bj.xhd.cn/kefu_1.htm"
  },
  "gz": {
    "name": "新航道郑州学校",
    "activity": "单报课程9折起，留学+课程打包双8折！",

    "alink": "http://chat.looyuoms.com/chat/chat/p.do?c=20002143&f=10069626&g=10067737&refer=2021sjbyh"
  },
  "cs": {
    "name": "新航道南京学校",
    "activity": "满5000减500，可与其他优惠同享",

    "alink": "http://dlt.zoosnet.net/LR/Chatpre.aspx?id=DLT51129102&lng=cn&e=xhd"
  },
  "cd": {
    "name": "新航道石家庄学校",
    "activity": "新航道暑期特惠，千元学习礼送不停",

    "alink": "http://chat.looyuoms.com/chat/chat/p.do?c=20002143&f=10111248&g=10084958&refer=sjzgdlj"
  },
  "sjz": {
    "name": "新航道唐山学校",
    "activity": "新航道暑期特惠，千元学习礼送不停",

    "alink": "http://chat.looyuoms.com/chat/chat/p.do?c=20002143&f=10086474&g=10085139?sem=hdtsbdzx"
  },
  "sy": {
    "name": "新航道邯郸学校",
    "activity": "新航道暑期特惠，千元学习礼送不停",

    "alink": "http://chat.looyuoms.com/chat/chat/p.do?c=20002143&f=10086474&g=10085139?sem=hdtsbdzx"
  },
  "fz": {
    "name": "新航道西安学校",
    "activity": "暑期课程优惠:小班8折,大班8.5折!",

    "alink": "http://chat.looyuoms.com/chat/chat/p.do?c=20002143&f=10116435&g=10066766"
  },
  "qz": {
    "name": "新航道哈尔滨学校",
    "activity": "直降1000元，加送胡敏雅思7代教材",

    "alink": "http://chat.looyuoms.com/chat/chat/p.do?c=20002143&f=10068026&g=10066734&refer=gdlj"
  },
  "zz": {
    "name": "新航道成都学校",
    "activity": "加入暑期班热力一夏，课程优惠8折起",

    "alink": "https://cd.xhd.cn/kefu_1.htm"
  },
  "nb": {
    "name": "新航道绵阳学校",
    "activity": "加入暑期班热力一夏，课程优惠8折起",

    "alink": "https://my.xhd.cn/kefu_1.htm"
  },
 
}; 